// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__rHxak","left":"style__left__a8L1j","right":"style__right__bl1rv","itemContainer":"style__itemContainer__AjsL3","colorBox":"style__colorBox__kzXug"};